import { Http } from '../features/core/utils/axios';

export interface ClaimEventTypes {
    [key: string]: string;
}

export interface CropTypes {
    [key: string]: string;
}

export interface PropertiesResponse {
    claim_event_types: ClaimEventTypes;
    crop_types: CropTypes;
}

let cachedProperties: PropertiesResponse | null = null;

export const PropertiesService = {
    /**
     * Get application properties (event types, crop types, etc.)
     */
    getProperties: async (): Promise<PropertiesResponse> => {
        // Return cached properties if already loaded
        if (cachedProperties) {
            return Promise.resolve(cachedProperties);
        }

        const response = await Http.get<PropertiesResponse>('mobile/properties/');
        cachedProperties = response.data;
        return response.data;
    },

    /**
     * Get translated event type name
     */
    getEventTypeName: (eventType: number): string => {
        if (!cachedProperties) {
            return eventType.toString();
        }
        return cachedProperties.claim_event_types[eventType.toString()] || eventType.toString();
    },

    /**
     * Get translated crop type name
     */
    getCropTypeName: (cropType: number): string => {
        if (!cachedProperties) {
            return cropType.toString();
        }
        return cachedProperties.crop_types[cropType.toString()] || cropType.toString();
    },

    /**
     * Clear cached properties
     */
    clearCache: (): void => {
        cachedProperties = null;
    }
};

